<div class="list-container">
  <div class="item-order">
    <span>Ordernar por empreendimento</span>
    <ul class="list-empt">
      <li *ngFor="let item of listEmp">
        <a (click)="send(item.desc)">{{ item.desc }}</a>
      </li>
    </ul>
    <span>Ordenar por endereço</span>
    <ul class="list-empt">
      <li *ngFor="let item of listOrder">
        <a (click)="send(item.desc)">{{ item.desc }}</a>
      </li>
    </ul>
  </div>
</div>